import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { App, Button, Dropdown, Popconfirm, Popover, Space, Tag } from 'antd';
import React, { useRef, useState } from 'react';
import { queryKeys } from '../../services/react-query/queryKeys';
import {
  MdAssignmentAdd,
  MdModeEditOutline,
  MdVisibility,
} from 'react-icons/md';
import Heading from '../../components/common/Heading/Heading';
import DynamicTableAnt from '../../hooks/DynamicTableAnt';
import {
  CheckOutlined,
  CloseCircleOutlined,
  DeleteOutlined,
  DollarOutlined,
  FileTextOutlined,
  PlusOutlined,
} from '@ant-design/icons';
import StatusTag from '../../hooks/StatusHook';
import { useNavigate } from 'react-router-dom';
import {
  cancelMaterialRequest,
  submitMaterialRequest,
} from '../../network/materialRequest';
import { PiDotsThreeVerticalBold } from 'react-icons/pi';
import PropsSearchTable from '../../components/common/PropsSearchTable/PropsSearchTable';
import { deleteSalesOrder, getSalesOrder } from '../../network/salesOrder';
import {
  ModalAddAmount,
  ModalTodoList,
} from '../../components/upeosoft/ModalApp/ModalApp';
import { TbDotsVertical } from 'react-icons/tb';
import { IoIosArrowRoundBack, IoIosArrowRoundForward } from 'react-icons/io';
import { useSelector } from 'react-redux';
import DashboardCards from '../Dashboard/DashboardCards';
import { FaFileInvoice } from 'react-icons/fa';
const SalesOrder = ({ t }) => {
  const navigate = useNavigate();
  const client = useQueryClient();
  const { currentLang } = useSelector((state) => state.user);
  const [open, setOpen] = useState(false);
  const [openTask, setOpenTask] = useState(false);
  const [idTask, setIdTask] = useState(null);
  const [totalValue, setTotalValue] = useState(0);
  const [id, setId] = useState(null);
  const searchInput = useRef(null);
  const searchInputMobile = useRef(null);
  const [textValue, setTextValue] = useState('');
  const [searchText, setSearchText] = useState({
    value: '',
    key: '',
  });
  const handleSearch = (selectedKeys, confirm, key) => {
    confirm();
    // console.log(`Searching for: ${selectedKeys[0]}, key: ${key}`);
    setSearchText({ value: selectedKeys[0], key });
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    confirm();
    setSearchText({ value: '', key: '' });
  };
  const props = ({ key, name }) =>
    PropsSearchTable({
      key: key,
      name: name,
      setTextValue: setTextValue,
      textValue: textValue,
      setSearchText: setSearchText,
      searchInputMobile: searchInputMobile,
      searchInput: searchInput,
      handleSearch: handleSearch,
      handleReset: handleReset,
      t: t,
    });
  const { message } = App.useApp();
  const handleRemove = useMutation({
    mutationFn: (id) => deleteSalesOrder(id),
    onSuccess: (data) => {
      console.log(data, 'data');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(data?.message ? data?.message : 'Deleted successfully');
      client.invalidateQueries({
        queryKey: [queryKeys.getSalesOrder, searchText.key, searchText.value],
      });
    },
    onError: () => {
      message.error('Something went wrong');
    },
  });
  const handleCancle = useMutation({
    mutationFn: (id) => cancelMaterialRequest('Sales Order', id),
    onSuccess: (data) => {
      console.log(data, 'data');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(data?.message?.message || 'Cancled successfully');
      client.invalidateQueries({
        queryKey: [queryKeys.getSalesOrder, searchText.key, searchText.value],
      });
    },
    onError: () => {
      message.error('Something went wrong');
    },
  });
  const handleSubmit = useMutation({
    mutationFn: (id) => submitMaterialRequest('Sales Order', id),
    onSuccess: (data) => {
      console.log(data, 'data');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(data?.message?.message || 'Submitted successfully');
      client.invalidateQueries({
        queryKey: [queryKeys.getSalesOrder, searchText.key, searchText.value],
      });
    },
    onError: () => {
      message.error('Something went wrong');
    },
  });
  const { data, isLoading } = useQuery({
    queryKey: [queryKeys.getSalesOrder, searchText.key, searchText.value],
    queryFn: () =>
      getSalesOrder({
        key: searchText.key,
        value: searchText.value,
      }),
    keepPreviousData: true,
  });
  const items = (record) => [
    {
      key: '1',
      label: t.edit,
      icon: record?.docstatus === 0 ? <MdModeEditOutline /> : <MdVisibility />,
      onClick: () => navigate(`/sales-order/edit/${record?.name}`),
    },
    {
      key: '2',
      label: t.materialRequest,
      icon: <FileTextOutlined />,
      onClick: () => navigate(`/sales-order/material-request/${record?.name}`),
      disabled: record?.docstatus === 1 ? false : true,
    },
    {
      key: '2-1',
      label: t.salesInvoice,
      icon: <FaFileInvoice />,
      onClick: () => navigate(`/sales-invoice-order/${record?.name}`),
      // disabled: record?.docstatus === 1 ? false : true,
    },
    {
      type: 'divider',
    },
    // {
    //   key: '3',
    //   label: t.CreateDownPaymentInvoice,
    //   icon: <DollarOutlined />,
    //   onClick: () => {
    //     setOpen(true);
    //     setId(record?.name);
    //     setTotalValue(record?.total);
    //   },
    // },
    // {
    //   key: '4',
    //   label: t.CreateFullPaymentInvoice,
    //   icon: <DollarOutlined />,
    //   onClick: () =>
    //     navigate(`/sales-order/sales-invoice-full-payment/${record?.name}`),
    // },
    {
      key: '5',
      label: t.paymentEntry,
      icon: <FileTextOutlined />,
      disabled: record?.docstatus === 1 ? false : true,
      onClick: () => navigate(`/sales-order/payment-entry/${record?.name}`),
    },
    {
      type: 'divider',
    },
    {
      key: '6',
      label: t.submit,
      icon: <CheckOutlined />,
      onClick: () => handleSubmit.mutate(record?.name),
      disabled: record?.docstatus === 0 ? false : true,
    },
    {
      key: '7',
      label: t.Cancel,
      icon: <CloseCircleOutlined />,
      onClick: () => handleCancle.mutate(record?.name),
      disabled: record?.docstatus === 1 ? false : true,
    },
    {
      key: '77',
      label: t.AssignTask,
      icon: <MdAssignmentAdd />,
      onClick: () => {
        setOpenTask(true);
        setIdTask(record?.name);
      },
    },
    {
      type: 'divider',
    },
    {
      key: '8',
      label: (
        <Popconfirm
          title={t.Delete + ` (${record?.name})`}
          okText={t.yes}
          cancelText={t.no}
          onConfirm={() => handleRemove.mutate(record?.name)}
        >
          <span style={{ color: 'red' }}>{t.Delete}</span>
        </Popconfirm>
      ),
      icon: <DeleteOutlined style={{ color: 'red' }} />,
    },
  ];
  const columns = [
    {
      title: t.Name,
      dataIndex: 'name',
      key: 'name',
      ...props({ key: 'name', name: t.Name }),
      render: (text, record) => {
        return (
          <span
            style={{ cursor: 'pointer' }}
            className="text-primary"
            onClick={() => {
              navigate(`/sales-order/edit/${record.name}`);
            }}
          >
            {text}
          </span>
        );
      },
    },
    {
      title: t.Customer,
      dataIndex: 'customer',
      key: 'customer',
      ...props({ key: 'customer', name: t.customer }),
    },
    {
      title: t.Total,
      dataIndex: 'total',
      key: 'total',
      sorter: {
        compare: (a, b) => a.total - b.total,
        multiple: 3,
      },
    },
    {
      title: t.totalTaxesAndCharges,
      dataIndex: 'base_total_taxes_and_charges',
      key: 'base_total_taxes_and_charges',
    },
    {
      title: t.advancePaid,
      dataIndex: 'advance_paid',
      key: 'advance_paid',
    },
    {
      title: t.status,
      dataIndex: 'status',
      key: 'status',
      render: (text, record) => <StatusTag status={record?.status} />,
      ...props({ key: 'status', name: t.status }),
    },
    {
      title: t.action,
      dataIndex: 'action',
      key: 'action',
      // width: 150,
      // align: 'center',
      render: (text, record) => {
        return (
          // <Space>
          //   <Dropdown
          //     menu={{ items: items(record) }}
          //     trigger={['click']}
          //     // placement="bottomCenter"
          //   >
          //     <Button
          //       size="small"
          //       type="text"
          //       icon={<TbDotsVertical size={20} />}
          //     />
          //   </Dropdown>
          // </Space>
          <Dropdown
            menu={{ items: items(record) }}
            // placement="bottomRight"
            overlayClassName="custom-dropdown"
            trigger={['click']}
          >
            <Button
              type="text"
              icon={<PiDotsThreeVerticalBold size={20} color="#86888C" />}
            />
          </Dropdown>
        );
      },
    },
  ];
  const dataTable = data?.data?.map((item, index) => {
    return {
      key: index,
      ...item,
    };
  });
  return (
    <div className="inventory">
      {/* <Heading title={t.sales} subTitle={t.salesOrder} path="/" /> */}
      <DashboardCards t={t} />
      <div className="mt-5">
        <DynamicTableAnt
          columns={columns}
          data={dataTable}
          loading={isLoading}
          setSearchText={setSearchText}
          Placeholder={t.searchByName}
          buttonModal={
            <Button
              type="primary"
              onClick={() => {
                navigate('/sales-order/add');
              }}
            >
              <PlusOutlined
                style={{
                  fontSize: '10px',
                }}
              />
              {t.addSalesOrder}
            </Button>
          }
          paginationTable={{
            pageSize: 10,
            // current: pageCount,
            // total: totalPages,
            hideOnSinglePage: true,
            showSizeChanger: false,
            // align: 'center',
            itemRender: (current, type, originalElement) => {
              if (type === 'prev') {
                return (
                  <div
                    // onClick={handlePrevClick}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '5px',
                      order: 1,
                    }}
                  >
                    <IoIosArrowRoundForward
                      size={16}
                      style={{
                        transform:
                          currentLang === 'en'
                            ? 'rotate(180deg)'
                            : 'rotate(0deg)',
                      }}
                    />
                    <span>{t.prev}</span>
                  </div>
                );
              }
              if (type === 'next') {
                return (
                  <div
                    // onClick={handleNextClick}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '5px',
                      order: -1,
                    }}
                  >
                    <span> {t.next}</span>
                    <IoIosArrowRoundBack
                      size={16}
                      style={{
                        transform:
                          currentLang === 'en'
                            ? 'rotate(180deg)'
                            : 'rotate(0deg)',
                      }}
                    />
                  </div>
                );
              }
              return originalElement;
            },
            // onChange: (page) => {
            //   setFilterData({ ...filterData, page });
            // },
          }}
        />
      </div>
      <ModalAddAmount
        t={t}
        open={open}
        setOpen={setOpen}
        id={id}
        setTotalValue={setTotalValue}
        totalValue={totalValue}
      />
      <ModalTodoList
        open={openTask}
        setOpen={setOpenTask}
        editId={idTask}
        doctype="Sales Order"
        t={t}
      />
    </div>
  );
};

export default SalesOrder;
